import {
  ArrowDownward,
  ArrowUpward
} from '@mui/icons-material';
import {
  Box,
  Typography,
  useTheme
} from '@mui/material';
import { SmallIconType } from 'modules/components/layer00/CustomIcon';



export type StyledTextChipProps = {
  upIsGood: boolean;
  label: string;
  type: 'STAT_INCREASE' | 'STAT_DECREASE' | 'PRIMARY';
};

export const FC = (props: StyledTextChipProps) => {
  const theme = useTheme();
  const statType2BackgroundColor: Record<StyledTextChipProps['type'], string> = {
    PRIMARY: theme.palette.primary.light05 ?? '#fff',
    STAT_DECREASE: (props.upIsGood ? theme.palette.error.main : theme.palette.primary.darker180) ?? '#fff',
    STAT_INCREASE: (props.upIsGood ? theme.palette.primary.darker180 : theme.palette.error.main) ?? '#fff'
  };

  const statType2TextColor: Record<StyledTextChipProps['type'], string> = {
    PRIMARY: theme.palette.primary.main,
    STAT_DECREASE: props.upIsGood ? theme.palette.error.contrastText : theme.palette.primary.contrastText,
    STAT_INCREASE: props.upIsGood ? theme.palette.primary.contrastText : theme.palette.error.contrastText
  };

  const statType2IconType: Record<StyledTextChipProps['type'], SmallIconType | ''> = {
    PRIMARY: '',
    STAT_DECREASE: 'STATNEG',
    STAT_INCREASE: 'STATPOS'
  };

  const iconType = statType2IconType[props.type];
  const textColor = statType2TextColor[props.type];
  const bgColor = statType2BackgroundColor[props.type];

  return (
    <Box display='inline-block'>
      <Box
        display='flex'
        flexDirection='row'
        alignItems='center'
        justifyContent='center'
        bgcolor={bgColor}
        gap='.25rem'
        padding='0.15rem 0.3rem'
        borderRadius='.375rem'
      >
        {iconType !== '' && (
          props.type === 'STAT_DECREASE' ? (
            <ArrowDownward
              fontSize='small'
              color='secondary'
            />
          ) : (
            <ArrowUpward
              fontSize='small'
              color='secondary'
            />
          )
        )}
        <Typography
          noWrap
          variant='styleTextChip'
          color={textColor}
        >
          {props.label}
        </Typography>
      </Box>
    </Box>
  );
};
